class TooltipComponent extends HTMLElement {
  constructor() {
    super();
    this.mode = this.getAttribute('mode');
    this.outsideClickHandler = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector('button');
    this.tooltip = this.querySelector('.shared-tooltip__info');
    this.id = this.getAttribute('id');

    if (!this.trigger || !this.tooltip) return;

    if (this.mode === 'hover') {
      this.trigger.addEventListener('mouseenter', (e) => {
        e.stopPropagation();
        this.openTooltip();
      });

      this.trigger.addEventListener('mouseleave', (e) => {
        e.stopPropagation();
        this.closeTooltip();
      });
    } else {
      this.trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleTooltip();
      });
    }

    this.trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.closeTooltip();
        this.trigger.focus();
      }
    });
  }

  disconnectedCallback() {
    this.removeOutsideClickListener();
  }

  toggleTooltip() {
    if (this.classList.contains('tooltip-active')) {
      this.closeTooltip();
    } else {
      this.openTooltip();
    }
  }

  openTooltip() {
    this.classList.add('tooltip-active');
    this.trigger.setAttribute('aria-expanded', 'true');

    this.setTooltipPosition();
    document.addEventListener('click', this.outsideClickHandler);
  }

  closeTooltip() {
    this.classList.remove('tooltip-active');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.trigger.classList.remove('is-active');
    this.removeOutsideClickListener();
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.closeTooltip();
    }
  }

  removeOutsideClickListener() {
    document.removeEventListener('click', this.outsideClickHandler);
  }

  setTooltipPosition() {
    const yLoc = this.getAttribute('data-position') || 'bottom';
    const xAttr = this.getAttribute('data-alignment') || 'center';

    const { left, right } = this.getBoundingClientRect();
    const { width: tooltipWidth } = this.tooltip.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    const spaceLeft = left;
    const spaceRight = viewportWidth - right;

    const checkWidth = xAttr === 'center' ? tooltipWidth / 2 : tooltipWidth;
    const xLoc = spaceRight < checkWidth ? 'right' : spaceLeft < checkWidth ? 'left' : xAttr;

    this.tooltip.classList.add(`tooltip-xLoc-${xLoc}`, `tooltip-yLoc-${yLoc}`);
  }
}

customElements.define('tooltip-component', TooltipComponent);
